interface FailureDetailMetaProps {
  createdAt: string
  lastRunDate: string | null
}

function formatDate(dateStr: string | null): string {
  if (!dateStr) return 'N/A'
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

function FailureDetailMeta({ createdAt, lastRunDate }: FailureDetailMetaProps) {
  return (
    <dl data-testid="failure-detail-meta" className="failure-detail-meta">
      <div className="failure-detail-meta-row">
        <dt className="meta-label">Created</dt>
        <dd className="meta-value">{formatDate(createdAt)}</dd>
      </div>
      <div className="failure-detail-meta-row">
        <dt className="meta-label">Last Run</dt>
        <dd className="meta-value">{formatDate(lastRunDate)}</dd>
      </div>
    </dl>
  )
}

export default FailureDetailMeta
